export const dateUtils = {
  methods: {
    // avoid js time zone issues, using Date 3 parts ctr, rather than its string ctr
    dateFromString(dateStr) {
      if (!dateStr) {
        return '';
      }
      const dateParts = dateStr.split('-');
      return new Date(dateParts[0], dateParts[1] - 1, dateParts[2]); // adjust month since 0 based
    }
  }
};
